import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames'
import tinycolor from 'tinycolor2'
import style from './icon.css';

export default class Icon extends React.Component {
  
  render() {
    const p = this.props
    let url, fontIcon, fontStyle

    if ( p.icon ) {
      if ( typeof p.icon === 'string' ) {
        url = p.icon
      } else if ( p.icon.type == 'image-icon' ) {
        url = p.icon.url
      } else if ( p.icon.type == 'font-icon' ) {
        fontIcon = p.icon.fontClass
        fontStyle = p.icon.color ? { color : tinycolor( p.icon.color ).toRgbString() } : null
      }
    } else if ( p.fontIcon ) {
      fontIcon = p.fontIcon
      fontStyle = p.fontColor ? { color : tinycolor( p.fontColor ).toRgbString() } : null
    } 
    if ( url ) {
      return <div className={classnames( style.icon, p.className )} style={{ backgroundImage : `url(${url})` }}/>
    }
    if ( fontIcon ) {
      return <div className={classnames( style.fontIcon, p.className )} style={fontStyle}><i className={fontIcon} /></div>
    }
    return p.showEmpty ? <div className={classnames( style.icon, p.className )}/> : null
   
  }
}
